import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EditarParametrizacaoHubRequest,
  IncluirParametrizacaoHubRequest,
  ListaParametrizacaoHubRequest,
  ListaParametrizacaoHubResponse,
  ValidaDisponibilidadeIataRequest,
} from 'src/app/@shared/models/requisicao-hub';
import { parametrizacaoHubRequest } from 'src/app/@shared/models/manifesto-transferencia/parametrizacao-hub/parametrizacao-hub';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: ListaParametrizacaoHubRequest | ValidaDisponibilidadeIataRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoHubService {

  constructor(private http: HttpClient) { }

  selecionarHubs(filialIdOrigem?: number): Observable<any[]> {
    return this.http.get<any[]>(
      `Hub/ListarHubs${filialIdOrigem ? `?filialIdOrigem=${filialIdOrigem}` : ''}`,
      httpOptions
    );
  }

  selecionarIATAs(filialIdOrigem?: number): Observable<any[]> {
    return this.http.get<any[]>(
      `Hub/ListarIATAs${filialIdOrigem ? `?filialIdOrigem=${filialIdOrigem}` : ''}`,
      httpOptions
    );
  }

  selecionarTodasHubs(filialIdOrigem?: number): Observable<any[]> {
    return this.http.get<any[]>(
      `Hub/ListarTodosHubs${filialIdOrigem ? `?filialIdOrigem=${filialIdOrigem}` : ''}`,
      httpOptions
    );
  }

  selecionarTodasIATAs(filialIdOrigem?: number): Observable<any[]> {
    return this.http.get<any[]>(
      `Hub/ListarTodasIATAs${filialIdOrigem ? `?filialIdOrigem=${filialIdOrigem}` : ''}`,
      httpOptions
    );
  }

  consultaFiltroHubs(obj: ListaParametrizacaoHubRequest): Observable<ListaParametrizacaoHubResponse[]> {
    return this.http.get<ListaParametrizacaoHubResponse[]>(
      `Hub/FiltrarGrid?${filtro(obj)}`,
      httpOptions
    );
  }

  ativarHub(obj: any): Observable<any> {
    return this.http.post<any>(`Hub/AtivarHub`, obj, httpOptions);
  }

  validaDisponibilidadeIata(obj?: ValidaDisponibilidadeIataRequest): Observable<any> {
    return this.http
      .get<any>(`Hub/ValidaDisponibilidadeIata?${filtro(obj)}`, httpOptions);
  }

  salvarHub(obj: parametrizacaoHubRequest): Observable<any> {
    return this.http.post<any>(`Hub/SalvarHub`, obj, httpOptions);
  }

  editarHub(obj: parametrizacaoHubRequest): Observable<any> {
    return this.http.put<any>(`Hub/AlterarHub`, obj, httpOptions);
  }
}
